import moment from 'moment';
import mtz from 'moment-timezone';
import { getCookie } from '../../common/utils/cookies';
import 'moment/min/locales';

/**
 * @param date
 * @returns localized date with format (ex: 4:30AM EST 20 August, 2021)
 */
export const getFormattedDeadlineDate = (date: number): string => {
  const locale = getCookie('locale_player') || 'EN_US';
  let formattedDate = '';
  // Date should not be 31/12/9999
  if (date < 253402257601913) {
    moment.locale(locale);
    formattedDate = mtz.tz(moment(date), mtz.tz.guess(true)).format('h:mmA z D MMMM, YYYY');
  }
  return formattedDate;
};

/**
 * @param date
 * @returns localized date with format (ex: 4:30AM EST 20 August, 2021)
 */
export const getTCPlusFormattedDeadlineDate = (date: string): string => {
  const locale = getCookie('locale_player') || 'EN_US';
  let formattedDate = '';
  // Date should not be 31/12/9999
  if (date) {
    moment.locale(locale);
    formattedDate = moment.tz(date, 'Asia/Kolkata').clone().tz(moment.tz.guess()).format('h:mmA z D MMMM, YYYY');
  }
  return formattedDate;
};

/**
 * @param date
 * @returns localized date with format (ex: 4:30AM EST 10/20/2020)
 */
export const getFormattedScheduledTaskDate = (date: number): string => {
  const locale = getCookie('locale_player') || 'EN_US';
  moment.locale(locale);
  return mtz.tz(date, mtz.tz.guess(true)).format('h:mmA z MM/DD/YYYY');
};

export const getValidateScheduledAssessmentDate = (date: string): number => {
  const validatedDate = parseInt(date.replace('/Date(', '').replace(')/', ''));
  if (isNaN(validatedDate)) {
    return 0;
  }
  return validatedDate;
};
